import { useQuery } from 'react-query';

import { getRechargeAmounts, mapSearch } from '@/services/myAccount';
import {
  getInitMyaccount,
  getInitMyAccountExtra,
  getProductsMyaccount,
} from '@/services/pins';
import { RequestUbicacionMapa } from '@/types/myAccount';

export const useGetInitMyaccount = () => {
  return useQuery('useGetInitMyaccount', async () => await getInitMyaccount(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });
};

export const useGetProductsMyaccount = () => {
  return useQuery(
    'useGetProductsMyaccount',
    async () => await getProductsMyaccount(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: false,
    }
  );
};

export const useGetInitMyAccountExtra = () => {
  return useQuery(
    'useGetInitMyAccountExtra',
    async () => await getInitMyAccountExtra(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: false,
    }
  );
};

// export const usePostDataRanking = () => {
//   return useMutation(async (date: string) => await getDataRanking(date));
// };

export const useGetRechargeAmounts = () => {
  return useQuery('my-amounts', async () => getRechargeAmounts(), {
    refetchOnWindowFocus: false,
  });
};

export const useMapSeach = (params: RequestUbicacionMapa) => {
  return useQuery('mapSearch', async () => mapSearch(params), {
    refetchOnWindowFocus: false,
  });
};
